import { render, staticRenderFns } from "./revenue-reports.vue?vue&type=template&id=37f5f85f&"
import script from "./revenue-reports.vue?vue&type=script&lang=js&"
export * from "./revenue-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports